import { autobind } from 'core-decorators';
import GenericAuthStore from '@src/mobx-store/root-store/auth/__generic-auth-store';
import { computed } from 'mobx';

/**
 * 第三方授权登录, 主要涵盖 qq, 微信, 江湖 daily, 微博
 * e.g.
 {
  "ua": "daily",
  "status": "success",
  "data": {
    "uid": "d7a0ad5e0298bf7f994d97f10f4687523f818472",
    "account": "hdt***008",
    "zone_name": "测试专区",
    "server_name": "聊天测试",
    "token": "4edafe7363c7495688422913bfbbd950",
    "force": "凌雪阁",
    "bodily": "成男",
    "person_name": "反复反反复复",
    "person_avatar": "https://dl.pvp.xoyo.com/static/avatars/moren4@2x.png",
    "is_wegame": 0,
    "session_id": "fPqi8KbQgtx9lxrcJ2ZQG7p5ULJq6RBgnPlz3ZlI",
    "request_id": "1d2bb5afb0740fc3014ca2729b920cbdd2935437"
  }
 }

 {
  "ua": "wechat",
  "status": "success",
  "data": {
    "login_type": "wechat",
    "uid": "Allen",
    "head_img_url": "//thirdwx.qlogo.cn/mmopen/vi_32/HuKwxgBvNJLedsftt74IdUFPibQQzj5CvibYJoWPdrhRicMkRaUKiaBsRKXu0o3OdQFyqIQ7ibK4HPZSZgFsupOzoCw/132",
    "city": "珠海",
    "sex": 1,
    "nickname": "Allen",
    "session_id": "HqTgRDjxcPvd9qlLSXVeSlQmZo9ZIazX4LR9KlIv",
    "request_id": "55504e5f01c89ceaa76a4086e79df14228e55839"
  }
 }

 */
@autobind
class ThirdPartyAuthStore extends GenericAuthStore {
  constructor() {
    super({ globalAuthName: 'THIRD_PARTY_AUTH' });
  }

  /**
   * 获取用户名
   * 如: xsj******001
   * @returns {boolean|*}
   */
  @computed
  get username() {
    return this.hasLogin ? this.data.nickname : '';
  }
}

const thirdPartyAuthStore = new ThirdPartyAuthStore();
export default thirdPartyAuthStore;
